import React, { useState } from 'react';
import axios from 'axios';

const MasterCardForm = () => {
  const [result, setResult] = useState(null); // Store the calculation result


  const XMLData  = `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/" xmlns:ns="http://schemas.datacontract.org/2004/07/">
   <soapenv:Header/>
   <soapenv:Body>
      <tem:Sale>
         <!--Optional:-->
         <tem:webReq>
            <!--Optional:-->
            <ns:Config>
               <!--Optional:-->
               <ns:EcrCurrencyCode>368</ns:EcrCurrencyCode>
               <!--Optional:-->
               <ns:EcrTillerFullName>Alaa</ns:EcrTillerFullName>
               <!--Optional:-->
               <ns:EcrTillerUserName>Alaa</ns:EcrTillerUserName>
               <!--Optional:-->
               <ns:IntegratorName>Alaa</ns:IntegratorName>
               <!--Optional:-->
               <ns:MerchantSecureKey>2800F02663994E418AC00BAB2F077EF0</ns:MerchantSecureKey>
               <!--Optional:-->
               <ns:Mid>2000002024</ns:Mid>
               <!--Optional:-->
               <ns:Tenant>test</ns:Tenant>
               <!--Optional:-->
               <ns:Tid>20002024</ns:Tid>
            </ns:Config>
            <!--Optional:-->
            <ns:EcrAmount>1000</ns:EcrAmount>
            <!--Optional:-->
            <ns:Printer>
               <!--Optional:-->
               <ns:EnablePrintPosReceipt>1</ns:EnablePrintPosReceipt>
               <!--Optional:-->
               <ns:EnablePrintReceiptNote>1</ns:EnablePrintReceiptNote>
               <!--Optional:-->
               <ns:InvoiceNumber>1</ns:InvoiceNumber>
               <!--Optional:-->
               <ns:PrinterWidth>40</ns:PrinterWidth>
               <!--Optional:-->
               <ns:ReceiptNote>1</ns:ReceiptNote>
               <!--Optional:-->
               <ns:ReferenceNumber>1</ns:ReferenceNumber>
            </ns:Printer>
         </tem:webReq>
      </tem:Sale>
   </soapenv:Body>
</soapenv:Envelope>`;

  const config = {
    headers: {
      'Content-Type': 'text/xml; charset=utf-8',
      'SOAPAction': 'http://tempuri.org/Add'
    }
  };

  const handleCalculate = async () => {
    try {
       // Generate XML with current input values
      const response = await axios.post('https://apex.switch.com.iq/Apex.SmartPos.EcrWebService/EcrComInterface.svc', XMLData, config);
      const parser = new DOMParser(); // Create a DOM parser
     console.log(response.data);

    } catch (error) {
      console.error('Error:', error);
      setResult('Error occurred');
    }
  };

  return (
    <div>
      <label>
        intA:
        
      </label>
      <br />
      <label>
        intB:
       
      </label>
      <br />
      <button onClick={handleCalculate}>Calculatetyy</button>
    
    </div>
  );
};

export default MasterCardForm;
